import React, { useState } from 'react';
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
} from '../../../Components';
import { DateRangePickerComponent } from '../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';
import { SearchIcon, UserOneIcon } from '../../../assets/icons';
import { useDebouncedAction } from '../../../Hooks/DebouncedAction';
import { getProperties } from '../../../Services';
import moment from 'moment';
import { ButtonBase } from '@material-ui/core';
import { useKeyGenerator } from '../../../Hooks/keyGenerator';

const platformTypeOptions = [
  { label: 'CRM', value: 'CRM' },
  { label: 'MyLeads', value: 'MyLeads' },
];
export default function GeneratedProposalLogFilters({
  setFilter,
  filter,
  ProposalLogsData,
}) {
  const [data, setData] = useState({
    unitRef: [],
    propertyName: [],
  });
  const debouncedSetFilterData = useDebouncedAction(setFilter);
  const [key, refresh] = useKeyGenerator();
  const getAllProperties = useDebouncedAction(async (value) => {
    const res = await getProperties({
      pageIndex: 0,
      pageSize: 25,
      search: value,
    });
    if (!(res && res.status && res.status !== 200))
      setData((prev) => ({ ...prev, propertyName: res?.result }));
    else setData((prev) => ({ ...prev, propertyName: res?.result }));
  });
  const onClearedFiltersClick = () => {
    setFilter({
      proposalName: null,
      generatedBy: null,
      sharedToName: null,
      platformType: null,
      unitRefNumber: null,
      propertyName: null,
      createdDateFrom: null,
      createdDateTo: null,
      pageIndex: 1,
      pageSize: 25,
    });
    refresh();
  };

  return (
    <div
      key={key}
      className='filter-section-proposalLog'
    >
      <div className='filter-left-section-proposalLog'>
        <AutocompleteComponent
          idRef='proposalNameRef'
          data={[
            ...new Set(
              ProposalLogsData.result?.map((item) => item?.proposalName)
            ),
          ]}
          inputPlaceholder='Proposal Name'
          multiple={false}
          wrapperClasses='w-25'
          chipsLabel={(option) => option || ''}
          displayLabel={(option) => option || ''}
          onChange={(_, newValue) => {
            setFilter((prev) => ({ ...prev, proposalName: newValue }));
          }}
          withoutSearchButton
          inputClasses='fields-content'
          inputStartAdornment={
            <SearchIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <Inputs
          idRef='generatedByRef'
          inputPlaceholder='Search by users'
          onInputChanged={(event) => {
            event.persist();
            const { value } = event.target;
            debouncedSetFilterData((prev) => ({
              ...prev,
              generatedBy: value,
            }));
          }}
          fieldClasses='fields-content'
          wrapperClasses='w-25'
          startAdornment={
            <UserOneIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <Inputs
          idRef='sharedToNameRef'
          inputPlaceholder='Search by contacts'
          wrapperClasses='w-25'
          onInputChanged={(event) => {
            event.persist();
            const { value } = event.target;
            debouncedSetFilterData((prev) => ({
              ...prev,
              sharedToName: value,
            }));
          }}
          fieldClasses='fields-content'
          startAdornment={
            <UserOneIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <Inputs
          idRef='unitRef'
          inputPlaceholder='Unit reference number'
          wrapperClasses='w-25'
          onInputChanged={(event) => {
            event.persist();
            const { value } = event.target;
            debouncedSetFilterData((prev) => ({
              ...prev,
              unitRefNumber: value,
            }));
          }}
          fieldClasses='fields-content'
          startAdornment={
            <SearchIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <AutocompleteComponent
          idRef='propertyRef'
          data={data.propertyName}
          inputPlaceholder='Search property'
          multiple={false}
          wrapperClasses='w-25'
          chipsLabel={(option) => option?.property?.property_name || ''}
          displayLabel={(option) => option?.property?.property_name || ''}
          onInputKeyUp={(event) => {
            event.persist();
            const { value } = event.target;
            getAllProperties(value);
          }}
          onChange={(_, newValue) => {
            setFilter((prev) => ({
              ...prev,
              propertyName: newValue?.property?.property_name,
            }));
          }}
          onOpen={() => {
            getAllProperties();
          }}
          withoutSearchButton
          inputClasses='fields-content'
          inputStartAdornment={
            <SearchIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <SelectComponet
          data={platformTypeOptions}
          textInput='label'
          valueInput='value'
          placeholder='Platform'
          emptyItem={{
            value: null,
            text: 'Select Platform ',
            isDisabled: false,
          }}
          value={filter.platformType}
          onSelectChanged={(value) => {
            setFilter((prev) => ({
              ...prev,
              platformType: value,
            }));
          }}
          wrapperClasses='w-25 fields-content'
        />
      </div>

      <div className='filter-right-section-proposalLog w-25'>
        <div className='w-100'>
          <DateRangePickerComponent
            idRef='DateRef'
            placeholder='DD/MM/YYYY'
            ranges={[
              {
                startDate: filter.createdDateFrom,
                endDate: moment(filter.createdDateTo),
                key: 'selection',
              },
            ]}
            onClearClicked={() =>
              setFilter((prev) => ({
                ...prev,
                createdDateFrom: null,
                createdDateTo: null,
              }))
            }
            onDateChanged={(e) => {
              setFilter((prev) => ({
                ...prev,
                createdDateFrom: new Date(
                  moment(e.selection.startDate).endOf('day')
                ),
                createdDateTo: new Date(
                  moment(e.selection.endDate).endOf('day')
                ),
              }));
            }}
            wrapperClasses='w-100 styled-data-picker '
          />
        </div>

        <div className='mt-3'>
          <ButtonBase
            onClick={onClearedFiltersClick}
            id='onClearedAllFiltersref'
            className='btns theme-solid bg-danger clear-all-btn'
          >
            <span className='mdi mdi-filter-remove m-1' />
            Clear Filters
          </ButtonBase>
        </div>
      </div>
    </div>
  );
}
